var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M3.65,6.5a.638.638,0,0,1,.65.625v1.25a5.1,5.1,0,0,0,5.2,5,5.1,5.1,0,0,0,5.2-5V7.125a.65.65,0,0,1,1.3,0v1.25a6.348,6.348,0,0,1-5.85,6.219v2.531h3.9a.625.625,0,1,1,0,1.25H4.95a.625.625,0,1,1,0-1.25h3.9V14.594A6.348,6.348,0,0,1,3,8.375V7.125A.638.638,0,0,1,3.65,6.5Z",
    transform: "translate(-3 1.625)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M11.5,10V3.75a2.551,2.551,0,0,0-2.6-2.5,2.551,2.551,0,0,0-2.6,2.5V10a2.551,2.551,0,0,0,2.6,2.5A2.551,2.551,0,0,0,11.5,10ZM8.9,0A3.827,3.827,0,0,0,5,3.75V10a3.827,3.827,0,0,0,3.9,3.75A3.827,3.827,0,0,0,12.8,10V3.75A3.827,3.827,0,0,0,8.9,0Z",
    transform: "translate(-2.4 0)",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic.09da786711852a0d3a9d65e4350353a4.svg";